/**
 * SEARCH INPUT
 * Composant de recherche réutilisable avec icône
 */

import { Search } from 'lucide-react';
import { type ChangeEvent } from 'react';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

export function SearchInput({ value, onChange, placeholder = 'Rechercher' }: SearchInputProps) {
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    onChange(e.target.value);
  }

  return (
    <div className="relative w-[17.5rem] h-9 bg-white rounded-md border border-zinc-200 shadow-xs">
      <div className="flex items-center gap-1 h-full px-3 py-1">
        <Search className="size-4 text-zinc-500" />
        <input
          type="text"
          value={value}
          onChange={handleChange}
          placeholder={placeholder}
          className="flex-grow text-sm leading-5 text-zinc-900 bg-transparent border-none outline-none min-w-0"
        />
      </div>
    </div>
  );
}
